import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { WA_MESSAGES } from "@/utils/whatsapp";
import { WhatsAppButton } from "@/components/WhatsAppButton";

export const DoctorCard = ({ doctor }) => (
  <article
    className="group flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
    data-testid={`doctor-card-${doctor.slug}`}
  >
    <div className="relative overflow-hidden">
      <img
        src={doctor.image}
        alt={`Portrait of ${doctor.name}, ${doctor.designation}`}
        loading="lazy"
        className="aspect-[4/3] w-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
      {doctor.isDemo && (
        <span className="absolute left-3 top-3 rounded-full bg-navy-900/85 px-3 py-1 text-[10px] font-semibold uppercase tracking-wider text-white">
          Sample Profile
        </span>
      )}
      <span className="absolute bottom-3 left-3 rounded-full bg-white/95 px-3 py-1 text-xs font-semibold text-navy-800">
        {doctor.specialty}
      </span>
    </div>
    <div className="flex flex-1 flex-col p-5">
      <h3 className="font-heading text-lg font-semibold text-navy-900">{doctor.name}</h3>
      <p className="mt-0.5 text-xs font-medium text-emerald-600">{doctor.qualifications} · {doctor.designation}</p>
      <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">{doctor.intro}</p>
      <div className="mt-5 flex flex-col gap-2 sm:flex-row">
        <Link
          to={`/doctors/${doctor.slug}`}
          className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-full bg-navy-800 px-4 py-2.5 text-xs font-semibold text-white transition-colors hover:bg-navy-700"
          data-testid={`doctor-card-view-profile-${doctor.slug}`}
        >
          View Profile <ArrowRight className="h-3.5 w-3.5" aria-hidden="true" />
        </Link>
        <WhatsAppButton message={WA_MESSAGES.doctor(doctor.name)} className="flex-1 px-4 py-2.5 text-xs" testId={`doctor-card-whatsapp-${doctor.slug}`}>
          WhatsApp
        </WhatsAppButton>
      </div>
    </div>
  </article>
);
